import type { GenericFieldConfig } from '@neo/blocks/forms/types'
import type { AppActionNodeData, SidebarComponentProps } from '../types'
import { v2validations } from '../config/validation.config'
import { GenericSidebarComponent } from './sidebar.base'

type FormValues = AppActionNodeData['config']

const fields = (nodeVars: string[]): GenericFieldConfig<FormValues> => {
  const validations = v2validations({ nodeVars }).app_action
  return [
    {
      name: 'name',
      componentType: 'input',
      label: 'Name',
      zodValidation: validations.shape.name,
      inputProps: {
        placeholder: 'Enter name',
      },
    },
  ]
}

// NODE_GEN: Update this code, do not commit directly
// Remove this comment after updating the code

export const AppActionSidebarComponent = (props: SidebarComponentProps<AppActionNodeData>) => {
  const { nodeVars } = props
  const formFields = fields(nodeVars)

  return <GenericSidebarComponent fields={formFields} {...props} />
}
